import { ErrorType, StateWrapper, WrapperProps } from '../../components'
import { useUserData } from '../../contexts'
import { UserQueryType } from '../../types'
import { StatusType } from '../fetch-state/types'

interface UserDataType {
  user?: UserQueryType['userInfo']
  employmentSummary?: UserQueryType['employmentSummaryInfo']
  membershipSummary?: UserQueryType['membershipSummaryInfo']
}

export const useUserRenderWrapper = () => {
  const { userState, refreshUserData } = useUserData()

  const UserRenderWrapper = ({ children }: WrapperProps) => {
    return (
      <StateWrapper
        fetchState={userState}
        fetchErrorType={ErrorType.FETCH_USER}
      >
        {children}
      </StateWrapper>
    )
  }

  let userData: UserDataType = {
    user: undefined,
    employmentSummary: undefined,
    membershipSummary: undefined
  }
  if (userState.status === StatusType.FETCHED) {
    const { userInfo, employmentSummaryInfo, membershipSummaryInfo } =
      userState.data
    userData = {
      user: userInfo,
      employmentSummary: employmentSummaryInfo,
      membershipSummary: membershipSummaryInfo
    }
  }

  return {
    UserRenderWrapper,
    ...userData,
    refreshUserData
  }
}
